/**
 * FIVB-aligned cancel-reason catalog, mirrored from
 * api/src/Cancel/Reasons.php. Keep them in sync — codes are stable and
 * referenced by stored match docs.
 */

export interface CancelReason {
    code: string;
    label: string;
    rule: string;
}

export const CANCEL_REASONS: CancelReason[] = [
    { code: 'force_majeure',         label: 'Force majeure (severe weather / natural disaster)', rule: 'FIVB Rule 17.3' },
    { code: 'venue_unfit',           label: 'Venue or playing area unfit for play',              rule: 'FIVB Rule 1' },
    { code: 'power_outage',          label: 'Power or lighting failure',                         rule: 'FIVB Rule 1.4' },
    { code: 'team_forfeit',          label: 'Team forfeit / no-show',                            rule: 'FIVB Rule 6.4 (default)' },
    { code: 'incomplete_team',       label: 'Incomplete team — unable to field 6 players',       rule: 'FIVB Rule 7.3 / 15.7' },
    { code: 'safety_security',       label: 'Safety or security incident',                       rule: 'FIVB referee discretion' },
    { code: 'public_health',         label: 'Public-health emergency',                           rule: 'Federation directive' },
    { code: 'officials_unavailable', label: 'Officials unavailable',                             rule: 'FIVB Rule 22.1' },
    { code: 'federation_directive',  label: 'Federation directive / scheduling conflict',        rule: 'Federation regulations' },
    { code: 'equipment_failure',     label: 'Equipment failure (net, antennae, ball)',           rule: 'FIVB Rule 2 / 3' },
    { code: 'other',                 label: 'Other (specify in details)',                        rule: '—' },
];

export function reasonLabel(code?: string | null): string {
    if (!code) return '';
    const r = CANCEL_REASONS.find(x => x.code === code);
    return r ? r.label : code;
}

export function reasonRule(code?: string | null): string {
    if (!code) return '';
    const r = CANCEL_REASONS.find(x => x.code === code);
    return r ? r.rule : '';
}
